var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewReportArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 7,
    viewBox: "0 0 4 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82533 3.2392C3.93698 3.35725 3.99978 3.51796 3.99978 3.6856C3.99978 3.85325 3.93698 4.01395 3.82533 4.13201L1.46641 6.64697C1.35657 6.76312 1.20831 6.82861 1.0536 6.8293C0.896847 6.83027 0.746184 6.76466 0.634891 6.64697C0.523247 6.52891 0.460449 6.36821 0.460449 6.20056C0.460449 6.03292 0.523247 5.87221 0.634891 5.75416L2.5751 3.6856L0.646685 1.61705C0.497095 1.45756 0.438673 1.22511 0.493427 1.00725C0.548181 0.789385 0.707792 0.619216 0.912136 0.56084C1.11648 0.502464 1.33451 0.564751 1.4841 0.724236L3.82533 3.2392Z",
    fill: "#40A0C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewReportArrow);
export default __webpack_public_path__ + "static/media/view-report-arrow.cea5b521098f6c8f8d585b7062dcee22.svg";
export { ForwardRef as ReactComponent };